import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const ShopIcon = ({ color = '#0D84FE', size = 22, ...props }) => (
  <svg
    width={size}
    viewBox="0 0 27 22"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M25.8 5.096 23.02.645C22.77.245 22.329 0 21.857 0H4.541c-.471 0-.913.245-1.162.645L.598 5.096c-1.436 2.299-.163 5.496 2.52 5.861a4.228 4.228 0 0 0 3.75-1.384 4.228 4.228 0 0 0 6.326 0 4.228 4.228 0 0 0 6.326 0 4.242 4.242 0 0 0 3.752 1.384c2.692-.36 3.969-3.558 2.529-5.86Zm-3.107 7.279c-.428 0-.853-.064-1.264-.163V16.5H4.969v-4.288a5.665 5.665 0 0 1-1.264.163 5.77 5.77 0 0 1-.771-.052 5.379 5.379 0 0 1-.703-.154v8.456c0 .76.613 1.375 1.371 1.375h19.203c.758 0 1.371-.614 1.371-1.375v-8.456a4.367 4.367 0 0 1-.703.154 5.946 5.946 0 0 1-.78.052Z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);

ShopIcon.propTypes = propTypes;

export default ShopIcon;
